/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InitialConcentration } from "./InitialConcentration";
import {
  InitialConcentrationFromJSON,
  InitialConcentrationFromJSONTyped,
  InitialConcentrationToJSON,
  InitialConcentrationToJSONTyped,
} from "./InitialConcentration";

/**
 *
 * @export
 * @interface PaginatedInitialConcentrationList
 */
export interface PaginatedInitialConcentrationList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<InitialConcentration>;
}

/**
 * Check if a given object implements the PaginatedInitialConcentrationList interface.
 */
export function instanceOfPaginatedInitialConcentrationList(
  value: object
): value is PaginatedInitialConcentrationList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedInitialConcentrationListFromJSON(
  json: any
): PaginatedInitialConcentrationList {
  return PaginatedInitialConcentrationListFromJSONTyped(json, false);
}

export function PaginatedInitialConcentrationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedInitialConcentrationList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(InitialConcentrationFromJSON),
  };
}

export function PaginatedInitialConcentrationListToJSON(
  json: any
): PaginatedInitialConcentrationList {
  return PaginatedInitialConcentrationListToJSONTyped(json, false);
}

export function PaginatedInitialConcentrationListToJSONTyped(
  value?: PaginatedInitialConcentrationList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(InitialConcentrationToJSON),
  };
}
